export default function ImageComponent( { data } ) {
    return (
      <div key = { data.id } className = "image">
        <img style = { { width: '100%', height: 'auto' } }
          src = { data.file ? data.file.url : data.external.url } alt = "Blog Image" />
        <p className = "caption">{ data.caption[0]?.plain_text }</p>
      </div>
    );
  }